import React, { useState } from "react";
import "./Withdrawal_History_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

function Withdrawal_History_card({ status = "Completed", badge = "Withdraw" }) {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const cards = [
    {
      id: 1,
      balance: "₹1, 234.00",
      type: "BANK CARD",
      time: "2026-02-08 12:16:45",
      orderNumber: "WD2026020812164370076195bWD2026020812164370076195b",
    },
    {
      id: 2,
      balance: "₹1, 234.00",
      type: "BANK CARD",
      time: "2026-02-08 12:16:45",
      orderNumber: "WD2026020812164370076195bWD2026020812164370076195b",
    },
    {
      id: 3,
      balance: "₹1, 234.00",
      type: "BANK CARD",
      time: "2026-02-08 12:16:45",
      orderNumber: "WD2026020812164370076195bWD2026020812164370076195b",
    },
    {
      id: 4,
      balance: "₹1, 234.00",
      type: "BANK CARD",
      time: "2026-02-08 12:16:45",
      orderNumber: "WD2026020812164370076195bWD2026020812164370076195b",
    },
  ];

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
      setCopiedIndex(null);
    }, 2000);
  };

   // 🔹 Badge background color
  const badgeStyle = {
    backgroundColor:
      badge === "Withdraw"
        ? "#F56664"
        : badge === "Deposit"
        ? "#009A55"
        : "#009A55",
    color: "#fff",
  };

  // 🔹 Status text color
  const statusStyle = {
    color:
      status === "Completed"
        ? "#37BB80"
        : status === "Failed"
        ? "#F56664"
        : status === "Pending"
        ? "#FF8000"
        : "#70798F",
  };


  return (
    <section className="Withdrawal_card_holder">
      {cards.map((card, index) => (
        <div className="Withdrawal_card" key={card.id}>
          <div className="card-top">

            {/* Badge */}
            <span
              className="badge-withdraw"
              style={badgeStyle}
            >
              {badge}
            </span>

            {/* Status */}
            <span
              className="status-completed"
              style={statusStyle}
            >
              {status}
            </span>

          </div>

          <div className="card-body">
            <div className="row-item">
              <span className="label">Balance</span>
              <span className="value amount">{card.balance}</span>
            </div>

            <div className="row-item">
              <span className="label">Type</span>
              <span className="value">{card.type}</span>
            </div>

            <div className="row-item">
              <span className="label">Time</span>
              <span className="value">{card.time}</span>
            </div>

            <div className="row-item">
              <span className="label">Order number</span>

              <div className="value order-id">
                <span className="order-text">{card.orderNumber}</span>

                <div
                  className="copy-wrapper"
                  onClick={() => handleCopy(card.orderNumber, index)}
                >
                  <FontAwesomeIcon icon={faCopy} className="copy-icon" />

                  {copiedIndex === index && (
                    <div className="copy-tooltip">Copied!</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default Withdrawal_History_card;